import { Button, Col, Row, Table } from "antd";
import * as Icon from "@ant-design/icons";
import { useCallback, useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import requests from "../lib/requests";
import { AuthContext } from "../context/AuthState";
import { NotificationContext } from "../context/NotificationProvider";

function WebhooksList() {
  const [foundData, setFoundData] = useState([]);
  const location = useLocation();
  const { setMessage } = useContext(NotificationContext);
  const { isAuthenticated, isLoading } = useContext(AuthContext);

  const webhookData: any = useCallback(async () => {
    const resData = await requests.get("/webhooks");
    return await resData.data;
  }, [location, isAuthenticated, isLoading]);

  useEffect(() => {
    webhookData().then((data: any) => {
      setFoundData(data.data);
    });
  }, [isAuthenticated, isLoading]);

  const handleDeleteWebhook = async (id: any) => {
    await requests.delete("/webhooks", {
      data: { id },
    });
    webhookData().then((data: any) => {
      setFoundData(data.data);
      setMessage({
        message: "Webhook eliminado correctamente",
        className: "successfulRequest",
      });
    });
  };

  return (
    <Col style={{ padding: "20px" }}>
      <Row style={{ padding: "20px", justifyContent: "flex-end" }}>
        <Col>
          {" "}
          <Link to={"/add"}>
            <Button type="primary">Crear webhook</Button>
          </Link>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          {" "}
          <Table
            columns={[
              {
                title: "ID",
                key: "id",
                dataIndex: "id",
              },
              {
                title: "Nombre",
                key: "name",
                dataIndex: "name",
              },
              {
                title: "URL del webhook",
                key: "api",
                dataIndex: "api",
                render: (data) => {
                  return (
                    <>
                      {data && `${window.location.origin}${data}`} { }
                    </>
                  );
                },
              },
              {
                title: "Comportamiento",
                key: "actions",
                render: (data) => {
                  return (
                    <div className="flexRow" style={{ gap: "40px" }}>
                      <Link to={`${data.id}/update`}>
                        <Icon.EditFilled />
                      </Link>
                      <Icon.DeleteFilled
                        onClick={() => handleDeleteWebhook(data.id)}
                        style={{ color: "#8B0000" }}
                      />
                      <Link to={`${data.id}`}>
                        <Icon.EyeFilled style={{ color: "#F4C430" }} />
                      </Link>
                    </div>
                  );
                },
              },
            ]}
            key={"data-table-333"}
            dataSource={foundData}
            loading={isLoading}
            onChange={webhookData}
          />
        </Col>
      </Row>
    </Col>
  );
}

export default WebhooksList;
